query getEmailMarketingPermission($encryptedEmail: String) {
  emailMarketingPermission: getEmailMarketingPermission(encryptedEmail: $encryptedEmail) {
    objectId
    type
    consent
  }
}
